import { Chip, type ChipProps } from "@mui/material";
import type { BatchPaymentStatus } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const STATUS_RESOURCES = Resources.Banking.BatchPayments.Status;

const STATUS_TO_COLOR: Record<BatchPaymentStatus, ChipProps["color"]> = {
  Created: "default",
  Initiated: "warning",
  Processing: "info",
  Success: "success",
  Fail: "error",
  Cancelled: "default",
};

type Props = {
  status: BatchPaymentStatus;
};

export const BatchPaymentStatusChip = ({ status }: Props) => {
  const { t } = useResource();

  const label = t(STATUS_RESOURCES[status]) || status;
  const color = STATUS_TO_COLOR[status] ?? "default";

  return <Chip label={label} color={color} size="small" />;
};
